import { ICON_LINE } from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FunctionOpenInNewTab } from "radium-omnibus";
import { STYLE_LINE_IOCN_FLOAT } from "../../utils/useStyle";

export const IconFloat = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <React.Fragment>
      {isMobile ? (
        <React.Fragment>
          {location.pathname === "/" || location.pathname === "/TH" ? (
            <div
              className=" scrollicon z-40 "
              onClick={() => {
                FunctionOpenInNewTab(
                  "https://page.line.me/?accountId=mylaundrythai"
                );
              }}
            >
              <div
                className={`-mb-16 bg-laundry-linebg_button w-border_blue h-input rounded-full p-[11px] cursor-pointer md:hover:bg-green-400 duration-100 `}
              >
                <ICON_LINE className="text-white " />
              </div>
            </div>
          ) : (
            ""
          )}
        </React.Fragment>
      ) : (
        <div
          className=" scrollicon z-50 "
          onClick={() => {
            FunctionOpenInNewTab(
              "https://page.line.me/?accountId=mylaundrythai"
            );
          }}
        >
          <div className={`${STYLE_LINE_IOCN_FLOAT} `}>
            <ICON_LINE className="text-white " />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
